// TODO: move this file to common api!
angular.module('zc.zenclerkS')
  .factory('ProjectUser', projectUser);

projectUser.$inject = ['$q', 'Api'];
function projectUser($q, Api) {
  return class ProjectUser {
    static all(apikey) {
      return Api.get(`/api/projects/apikey:${apikey}/users`, {}, {cache: false})
        .then(res => {
          if(res.data.success) {
            return res.data.users;
          }
          return $q.reject(res);
        });
    }

    static create(apikey, user) {
      return Api.post(`/api/projects/apikey:${apikey}/users`, { user })
        .then(res => {
          if(res.data.success) {
            return res.data.user;
          }
          return $q.reject(res);
        });
    }


    static destroy(apikey, id) {
      return Api.delete(`/api/projects/apikey:${apikey}/users/${id}`)
        .then(res => {
          if(res.data.success) {
            return res.data.user;
          }
          return $q.reject(res);
        });
    }
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/project_user.service.js